export default "__VITE_ASSET__BAcgyVM7__"